import { NavMobile } from './NavMobile';
(function ($) {
    $(function () {
        var $header = $('header');
        var navMobile = new NavMobile($header, $('nav.mobile-navigation'));
        var mqMobile = window.matchMedia("(min-width: ".concat(window.BCB.nav_breakpoint, "px)"));
        // *********************************
        // INIT
        activateNavigations();
        mqMobile.addEventListener('change', activateNavigations);
        /**
         * activate navigations, depending on the screen size
         */
        function activateNavigations() {
            if (mqMobile.matches) {
                navMobile.destroy();
            }
            else {
                navMobile.init();
            }
        }
        /** ***************************
         * resize header depending on scroll state.
         */
        var triggerTop = 100;
        var headerSizeObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    $header.removeClass('header-small');
                }
                else {
                    $header.addClass('header-small');
                }
            });
        }, {});
        var $headerSizeTrigger = $("<div style=\"position: absolute; top: ".concat(triggerTop, "px;\"></div>"));
        $('body').append($headerSizeTrigger);
        headerSizeObserver.observe($headerSizeTrigger[0]);
        /** ***************************
         * recolor header depending on underlying sections
         */
        var activeSections = [];
        var sectionsObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                // add or remove sections from activeSections
                var section = $(entry.target);
                if (entry.isIntersecting) {
                    activeSections.push(section);
                }
                else {
                    activeSections = activeSections.filter(function (el) {
                        return !el.is(section);
                    });
                }
                // sort active sections so the top-most is first
                activeSections.sort(function (a, b) {
                    return a.offset().top - b.offset().top;
                });
                // check if this section is dark and set the hedaer accordingly
                if (activeSections.length > 0) {
                    if (activeSections[0].hasClass('dark')) {
                        $header.addClass('light');
                    }
                    else {
                        $header.removeClass('light');
                    }
                }
            });
        }, { rootMargin: '-50px' });
        // keep an eye on those sections
        $('main>section').each(function (i, el) {
            sectionsObserver.observe(el);
        });
    });
})(jQuery);
